jQuery(document).ready(function() {

    let grc_wrapper    = document.getElementById("grc-wrapper");
    
    if ( grc_wrapper !== null ) {
        let grc_sitekey    = grc_wrapper.getAttribute('data-grc-sitekey');
    }
    
    let login_form     = document.getElementById("loginform");
    let grc_response   = document.getElementById("grc-response");
    let submit_button  = document.getElementById("wp-submit");

    if ( login_form !== null ) {

        if ( grc_response !== null ) {


          grecaptcha.ready(function() {
              grecaptcha.execute( grc_sitekey, {action: 'login'})
              .then(function(token) {     // Verify the token on the server.
                  //document.getElementById( 'g-recaptcha-response' ).value=token;
                  jQuery(".grecaptcha-badge").prependTo("#main");
                  console.log('Google reCaptcha is ready!');
              });
          });


             submit_button.addEventListener("click", function ( event ) {

                   event.preventDefault();
                   grecaptcha.ready(function() {
                       grecaptcha.execute( grc_sitekey, {action: 'login'})
                       .then(function(token) {     // Verify the token on the server.
                           document.getElementById( 'grc-response' ).value=token;
                           //console.log('reCaptcha is ready! render=>'+grc_sitekey);
                           login_form.submit();
                         });
                   });

             });
        }
    }
});
